export const setError = (field, errors, formikContext) => {
  formikContext.setFieldTouched(field, true, true);
  setTimeout(() => {
    formikContext.setFieldError(field, errors);
  }, 200)
}
